// create the namespace com.jacada.common.injector
window.com = window.com || {};
com.jacada = com.jacada  || {};
com.jacada.common = com.jacada.common || {};
com.jacada.common.injector = com.jacada.common.injector || {};
com.jacada.common.injector.serviceInjectors = com.jacada.common.injector.serviceInjectors || []; // Array



// WEBPACK FOOTER //
// ./src/namespace.js